import appConfig from '@/features/app/constants/app-config';
import getAccessTokenExpiryTime from '@/features/auth/functions/getAccessTokenExpiryTime';
import { _clientNow } from '@/shared/functions/timezone';

export default function isAccessTokenStillValid(
  useCookieStorage: boolean,
  enableLegacyTokenStorage: boolean,
  threshold = appConfig.tokenCheckThreshold
) {
  const expiryTime = getAccessTokenExpiryTime(useCookieStorage, enableLegacyTokenStorage);
  if (!expiryTime) return false;
  return _clientNow().isBefore(expiryTime.subtract(threshold, 'milliseconds'));
}
